import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import Button from 'srcReact/components/common2/Button'
import Spinner from 'srcReact/components/common2/Spinner'
import { mixrActions } from 'srcReact/Mixr/actions'
import styles from './styles.module.scss'

export default function EditMixrPopup({
  loading,
  editSuccess,
  dataToUpdateForRecMixr,
  mixrId,
  isRecurrentMixr,
  closeModal
}) {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const [buttonTriggered, setButtonTriggered] = useState('')

  const editMixr = (recurrenceUpdate) => {
    if (mixrId > 0) {
      setButtonTriggered(recurrenceUpdate)
      dispatch(mixrActions.editMixr(mixrId, { ...dataToUpdateForRecMixr }, recurrenceUpdate))
    }
  }

  useEffect(() => {
    if (editSuccess && !loading) {
      closeModal()
    }
  }, [editSuccess])
  return (
    <div className={styles.container}>
      {isRecurrentMixr && (
        <React.Fragment>
          <h1 className={styles.title}>{t('event.create.editMixrPopupTitle')}</h1>
          <div className={styles.buttonWrapperRec}>
            <Button
              size='large'
              text={
                loading && buttonTriggered === 'unique' ? (
                  <Spinner customCss={styles.spinner} isWhite={true} />
                ) : (
                  t('mixrHome.btnCancelEditOne')
                )
              }
              handleClick={() => editMixr('unique')}
            />
            <Button
              customStyle={styles.cancelAll}
              size='large'
              text={
                loading && buttonTriggered === 'future' ? (
                  <Spinner customCss={styles.spinner} isWhite={true} />
                ) : (
                  t('mixrHome.btnCancelEditFuture')
                )
              }
              handleClick={() => editMixr('future')}
            />
            <Button
              customStyle={styles.cancelAll}
              size='large'
              text={
                loading && buttonTriggered === 'all' ? (
                  <Spinner customCss={styles.spinner} isWhite={true} />
                ) : (
                  t('mixrHome.btnCancelEditAll')
                )
              }
              handleClick={() => editMixr('all')}
            />

            <Button
              customStyle={styles.close}
              size='large'
              text={t('global.cancel')}
              style='tertiary'
              handleClick={closeModal}
            />
          </div>
        </React.Fragment>
      )}
    </div>
  )
}
